import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { getBriskV2ReceiptUrl } from "../../../Service/BriskV2Service";
import { isSafeLink } from "../BriskCertificateList/briskV2ListUtils";
import { rupees } from "./briskWalletUtils";

/** One figure in a bordered card (Total Credit, Total Debit, Balance ...). */
export const MoneyCard = ({ label, value, tone = "#101828", note = "" }) => (
  <Box sx={{ border: "1px solid #EAECF0", borderRadius: "10px", p: 2, backgroundColor: "#fff", height: "100%" }}>
    <Typography sx={{ fontSize: 13, color: "#667085", fontWeight: 500 }}>{label}</Typography>
    <Typography sx={{ fontSize: { xs: 20, sm: 22 }, fontWeight: 600, color: tone, mt: 0.5 }}>{rupees(value)}</Typography>
    {note && <Typography sx={{ fontSize: 12, color: "#667085", mt: 0.5 }}>{note}</Typography>}
  </Box>
);

/** Shown when the wallet's balance is not what its own history adds up to. Reading never changes anything. */
export const MismatchAlert = ({ wallet }) =>
  wallet && wallet.matches === false ? (
    <Alert severity="warning" sx={{ mb: 2, width: "100%" }}>
      The Brisk balance does not match its history by {rupees(wallet.ledgerDifference)}. Nothing was changed. Please tell
      support.
    </Alert>
  ) : null;

/** The super admin's "Agency" filter options, from the wallet summary rows. */
export const agencyOptions = (rows) => [
  { _id: "all", label: "All agencies", value: "" },
  ...(rows || []).map((r) => ({ _id: r.clientId, label: r.name || r.email || r.clientId, value: r.clientId })),
];

/** Opens a top-up receipt in a new tab (a short-lived link; the tab is opened at click time so it is never blocked). */
export const openReceipt = async (key) => {
  const tab = window.open("", "_blank");
  const res = await getBriskV2ReceiptUrl(key);
  if (!res || res.error || !isSafeLink(res.url)) {
    if (tab) tab.close();
    ToastError((res && res.message) || "The receipt is not available right now");
    return;
  }
  if (tab) tab.location.href = res.url;
  else window.open(res.url, "_blank", "noopener,noreferrer");
};
